import {LOG_IN_STATUS, FORGET_PASSWORD, SHOW_FACEBOOK_POPUP,
    RESET_PASSWORD_EMAIL_SENT, CHANGE_PASSWORD,
    RESET_STATUS, ENABLE_FB_BUTTON} from "../../actions/actionTypes";

export function loginReducer(state, action) {
    state = state || {};
    switch (action.type) {
        case LOG_IN_STATUS: {
            const error = getLoginError(action.status.status);
            return Object.assign({}, state, {
                status: error.errorMessage,
                component: error.errorComponent,
                showCreateFBAccount: error.errorMessage !== 'Ok' && action.status.facebookId !== undefined
            });
        }
        case FORGET_PASSWORD:
            return Object.assign({}, state, {isForgetPassword: action.isForgetPassword});
        case SHOW_FACEBOOK_POPUP:
            return Object.assign({}, state, {
                showCreateFBAccount: action.showCreateFBAccount,
                email: action.email
            });
        case RESET_STATUS:
            return Object.assign({}, state, {
                showCreateFBAccount: action.showCreateFBAccount,
                status: null,
                component: null,
                email: null
            });
        case RESET_PASSWORD_EMAIL_SENT:
            return Object.assign({}, state, {
                isResetPasswordEmailSent: action.isResetPasswordEmailSent
            });
        case CHANGE_PASSWORD:
            return Object.assign({}, state, {
                isNeedToChangePassword: action.isNeedToChangePassword
            });
        case ENABLE_FB_BUTTON:
            return Object.assign({}, state, {
                enableFBButton: action.enableFBButton
            });
        default:
            return state;
    }
}

function getLoginError(status) {
    switch (status) {
        case 'WrongEmail': {
            return {
                errorMessage: 'noAccount',
                errorComponent: 'email'
            };
        }
        case 'InvalidEmail': {
            return {
                errorMessage: 'Invalid email',
                errorComponent: 'email'
            };
        }
        case 'MissingEmail': {
            return {
                errorMessage: 'Please fill Email',
                errorComponent: 'email'
            };
        }
        case 'WrongPassword': {
            return {
                errorMessage: 'Incorrect password',
                errorComponent: 'password'
            };
        }
        case 'MissingPassword': {
            return {
                errorMessage: 'Password is required',
                errorComponent: 'password'
            };
        }
        case 'ChangePassword': {
            return {
                errorMessage: 'ChangePassword',
                errorComponent: 'password'
            };
        }
        case 'OkExistingForFarm':
        case 'Ok': {
            return{
                errorMessage: 'Ok'
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/login/loginReducer.js